module.exports = __webpack_public_path__ + "img/project-sprite.1c2e7465.png";